import {createStyles} from '@mantine/core';
import React from 'react';

import {FieldDefinitionType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

import {
  LIBRARY_PARAMETER_DEFINITION_DATA_TYPES,
  LibraryParameterDefinitionDataType,
} from '../ParameterLibraryTypes';
import {LIBRARY_PARAMETER_DEFINITION_DATA_TYPE_TO_FRIENDLY_NAME} from './ParameterLibraryListing';

const useStyles = createStyles(() => ({
  icon: {
    marginRight: '4px',
  },
}));

const DATA_TYPE_TO_ICON: Record<LibraryParameterDefinitionDataType, BenchlingIconName> = {
  [FieldDefinitionType.FLOAT]: 'number',
  [FieldDefinitionType.TEXT]: 'text',
};

/** @package */
export interface LibraryParameterDefinitionDataTypeSelectorProps {
  selectedType: LibraryParameterDefinitionDataType;
  onChangeSelection: (parameterType: LibraryParameterDefinitionDataType) => void;
}

export function LibraryParameterDefinitionDataTypeSelector(
  props: LibraryParameterDefinitionDataTypeSelectorProps
): JSX.Element {
  const {classes} = useStyles();
  const placeholderText = 'Select data type';
  const selectedOptionLabel = props.selectedType ? (
    <div>
      <BenchlingIcon icon={DATA_TYPE_TO_ICON[props.selectedType]} className={classes.icon} />
      {LIBRARY_PARAMETER_DEFINITION_DATA_TYPE_TO_FRIENDLY_NAME[props.selectedType]}
    </div>
  ) : (
    placeholderText
  );
  return (
    <SelectDropdown
      displayName={selectedOptionLabel}
      buttonSize={ButtonSize.MINI}
      menu={
        <Menu value={props.selectedType}>
          {LIBRARY_PARAMETER_DEFINITION_DATA_TYPES.map((type: LibraryParameterDefinitionDataType) => (
            <Option
              icon={DATA_TYPE_TO_ICON[type]}
              key={type}
              value={type}
              onSelect={() => {
                props.onChangeSelection(type);
              }}
              isSelected={props.selectedType === type}
            >
              {LIBRARY_PARAMETER_DEFINITION_DATA_TYPE_TO_FRIENDLY_NAME[type]}
            </Option>
          ))}
        </Menu>
      }
      dataTestAttrs={{component: 'LibraryParameterDefinitionDataTypeSelector', element: 'dropdown'}}
    />
  );
}
